export const MENU_ITEMS = [
  {
    name: 'companyManagement',
    to: '/company/management',
    color: 'teal',
    icon: 'cog',
    role: 'ADMIN,PARTNER',
  },
  {
    name: 'facilityManagement',
    to: '/facility/management',
    color: '#800000',
    icon: 'building',
    role: 'ADMIN,PARTNER,CUSTOMER',
  },
  {
    name: 'assetManagement',
    to: '/asset/management',
    color: '#3D087B',
    icon: 'play',
    role: 'ADMIN,PARTNER,CUSTOMER,TECHNICIAN',
  },
  {
    name: 'deviceManagement',
    to: '/device/management',
    color: '#1678C2',
    icon: 'plug',
    role: 'ADMIN,PARTNER,TECHNICIAN',
  },
  {
    name: 'alertsAndManagement',
    to: '/alert/management',
    color: '#303D54',
    icon: 'alarm',
    role: 'ADMIN,PARTNER,CUSTOMER',
  },
  {
    name: 'userManagement',
    to: '/user/management',
    color: '#808000',
    icon: 'user',
    role: 'ADMIN',
  },
]
